import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Nav, NavItem } from 'reactstrap'
import { AppNavbarBrand, AppSidebarToggler } from '@coreui/react'
import logo from '../../assets/img/brand/logo.svg'
import sygnet from '../../assets/img/brand/sygnet.svg'

const propTypes = {
  children: PropTypes.node
}

const defaultProps = {}

class DefaultHeader extends Component {
  render () {
    // eslint-disable-next-line
    const { children, logout, ...attributes } = this.props

    return (
      <React.Fragment>
        <AppSidebarToggler className='d-lg-none' display='md' mobile />
        <AppNavbarBrand
          full={{ src: logo, width: 89, height: 25, alt: 'oneZone' }}
          minimized={{ src: sygnet, width: 30, height: 30, alt: 'oneZone' }}
        />
        <AppSidebarToggler
          className='d-md-down-none'
          style={{ marginRight: 'auto' }}
          display='lg'
        />
        <Nav>
          <NavItem>
            <Button
              color={'ghost-primary'}
              onClick={() => logout()}
              id={'logout-button'}
            >
              Logout
            </Button>
          </NavItem>
        </Nav>
        {/* <AppAsideToggler className="d-lg-none" mobile /> */}
      </React.Fragment>
    )
  }
}

DefaultHeader.propTypes = propTypes
DefaultHeader.defaultProps = defaultProps

export default DefaultHeader



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultHeader.js